module.exports = __webpack_public_path__ + "static/media/The-West-App_Desktop-Banner-906x212px.c38de57b.webp";